// extracted by mini-css-extract-plugin
export default {"mobile":"App_mobile__dQAHf"};